import {NavigateFunction} from 'react-router'

import {storeResetSession} from './forgotSetPasswordStorage'
import {PasswordResetVerifyResult} from './types'

export function goToResetPassword(
  navigate: NavigateFunction,
  result: PasswordResetVerifyResult
): void {
  const {resetSessionToken, emailPurpose, email, username} = result
  storeResetSession(resetSessionToken, emailPurpose, email, username)
  navigate('/auth/reset-password', {
    state: {resetSessionToken, emailPurpose, email, username},
  })
}
